import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class TaggedMentionsReport extends ApplicationRecord {
  static jsonapiType = "tagged_mentions_reports";

  @Attr() after: number;

  @Attr() before: number;

  @Attr() content: string[];

  @Attr() createdAt: string;

  @Attr() fileUrl: string;

  @Attr() format: string;

  @Attr() htmlUrl: string;

  @Attr() recipients: string[];

  @Attr() status: string;

  @Attr() subject: string;

  @BelongsTo() user: User;
}

export default TaggedMentionsReport;
